import * as React from 'react';
export const bunqSvg = React.forwardRef(function bunqSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M0 0h32v32H0z',
        fill: '#fff',
      }),
      /*#__PURE__*/ React.createElement(
        'g',
        {
          fillRule: 'nonzero',
        },
        /*#__PURE__*/ React.createElement('path', {
          d: 'M0 0h2.909v32H0z',
          fill: '#238647',
        }),
        /*#__PURE__*/ React.createElement('path', {
          d: 'M1.455 0h2.909v32H1.455z',
          fill: '#2f9b47',
        }),
        /*#__PURE__*/ React.createElement('path', {
          d: 'M4.364 0h2.909v32H4.364z',
          fill: '#62b64f',
        }),
        /*#__PURE__*/ React.createElement('path', {
          d: 'M7.273 0h2.909v32H7.273z',
          fill: '#89cc53',
        }),
        /*#__PURE__*/ React.createElement('path', {
          d: 'M10.182 0h2.909v32h-2.909z',
          fill: '#3db8ad',
        }),
        /*#__PURE__*/ React.createElement('path', {
          d: 'M13.091 0H16v32h-2.909z',
          fill: '#3394d7',
        }),
        /*#__PURE__*/ React.createElement('path', {
          d: 'M16 0h2.909v32H16z',
          fill: '#2872bc',
        }),
        /*#__PURE__*/ React.createElement('path', {
          d: 'M18.909 0h2.909v32h-2.909z',
          fill: '#1d5c84',
        }),
        /*#__PURE__*/ React.createElement('path', {
          d: 'M21.818 0h2.909v32h-2.909z',
          fill: '#993233',
        }),
        /*#__PURE__*/ React.createElement('path', {
          d: 'M24.727 0h2.909v32h-2.909z',
          fill: '#e13030',
        }),
        /*#__PURE__*/ React.createElement('path', {
          d: 'M27.636 0h2.909v32h-2.909z',
          fill: '#f28825',
        }),
        /*#__PURE__*/ React.createElement('path', {
          d: 'M30.545 0h1.5v32h-1.5z',
          fill: '#f5c836',
        }),
        /*#__PURE__*/ React.createElement('path', {
          d: 'M4.36 18.9H2.91v-8.71h1.6v3.52a2.97 2.97 0 1 1-.1 4.69l-.05.52zm3.71-2.83c0-1.06-.84-1.93-1.86-1.93s-1.86.87-1.86 1.93.84 1.94 1.86 1.94a1.9 1.9 0 0 0 1.86-1.94zm6.27-2.98h1.18v3.29a2.68 2.68 0 0 1-5.35 0v-3.29h1.19v3.27c0 .9.67 1.63 1.48 1.63.83 0 1.5-.72 1.5-1.63V13.1zm6.45 5.82h1.17v-3.13a2.68 2.68 0 0 0-5.35 0v3.13h1.2v-3.13c0-.9.66-1.64 1.48-1.64.83 0 1.5.73 1.5 1.64zm7-5.66h1.32v8.57h-1.46v-3.36a2.97 2.97 0 1 1 .09-4.69l.06-.52zm-3.7 2.82a1.9 1.9 0 0 0 1.86 1.94 1.9 1.9 0 0 0 1.85-1.94 1.9 1.9 0 0 0-1.85-1.93 1.9 1.9 0 0 0-1.86 1.93z',
          fill: '#fff',
        }),
      ),
    ),
  );
});
bunqSvg.defaultProps = {
  height: '32',
  viewBox: '0 0 32 32',
  width: '32',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var bunq = {
  category: 'brand',
  colorable: false,
  name: 'bunq',
  svg: bunqSvg,
};
